// extracted by mini-css-extract-plugin
export var active = "_d7-7";
export var container = "_d7-0";
export var evenWidth = "_d7-4";
export var large = "_d7-5";
export var outlet = "_d7-8";
export var slide = "_d7-2";
export var small = "_d7-6";
export var tab = "_d7-3";
export var tabs = "_d7-1";